/*!
 * Stimpack Control - Media
 *
 * @version : 1.0.0
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlMedia = function(root, options)
    {
        var _t = this,
            root = $(root);

        this.o = $.extend({
            multiple        : false,
            itemTemplate    : ''
        }, options);

        this.el = {
            root            : root,
            add             : root.find('.sp-control-media-add'),
            //encodedOutput   : root.find('.sp-control-media-encoded-output'),
        };

        this.init();
    };

    /*
     * Get value
     */
    spControlMedia.prototype.init = function()
    {
        var _t = this;

        this.el.add.on('click', function (e) {
            e.preventDefault();
            _t.openLibrary();
        });

        this.el.root.on('click', '.sp-control-media-item-remove', function (e) {
            e.preventDefault();
            _t.removeItem($(this).closest('.sp-control-media-item'));
        });

        this.items = {};
    }

    /*
     * Refresh
     */
    spControlMedia.prototype.refresh = function()
    {
        if (this.items && Object.keys(this.items).length > 0 && !this.o.multiple)
        {
            this.el.add.hide();
        }
        else
        {
            this.el.add.show();
        }
    }

    spControlMedia.prototype.initLibrary = function()
    {
        var _t = this;

        this.el.library =  wp.media({
            title: 'Select or Upload Media',
            button: {
                text: 'Use this media'
            },
            library: {
                type: ['image']
            },
            multiple: this.o.multiple
        });

        this.el.library.on('select', function() {

            var attachment = _t.el.library.state().get('selection').first().toJSON();

            _t.el.library.state().get('selection').each(function(item) {
                _t.addItem(item.toJSON());
            });

            // Send the attachment URL to our custom image input field.
            //imgContainer.append( '<img src="'+attachment.url+'" alt="" style="max-width:100%;"/>' );
        });
    }

    spControlMedia.prototype.openLibrary = function()
    {
        if (!this.el.library)
        {
            this.initLibrary();
        }

        this.el.library.open();
    }

    spControlMedia.prototype.addItem = function(data)
    {
        if (data.id)
        {
            var item = $(this.o.itemTemplate);

            item.data('sp-item-id', data.id);
            item.attr('data-sp-item-id', data.id);
            item.find('input').val(data.id);

            item.find('.sp-control-media-item-preview-image').css('background-image', 'url(' +
            (data.sizes && data.sizes.thumbnail ? data.sizes.thumbnail.url : data.url)
            + ')');

            this.el.root.find('.sp-control-media-items-inner').append(item);

            this.items[data.id] = item;
        }

        this.el.root.trigger('spControlMedia::add', this);
        this.el.root.trigger('spControlMedia::change', this);

        this.refresh();
    }

    spControlMedia.prototype.removeItem = function(item)
    {
        var id = item.data('sp-item-id');

        item.remove();
        delete(this.items[id]);

        this.el.root.trigger('spControlMedia::remove', this);
        this.el.root.trigger('spControlMedia::change', this);

        this.refresh();
    }


    $.fn.spControlMedia = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-media');

            $(this).attr('data-sp-control-media', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, JSON.parse(spBase64Decode(_options)));
                }
            }

            this.spControlMedia = new spControlMedia(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-media]').each(function() {
        $(this).spControlMedia();
    });

})(jQuery);
